<template lang="pug">
    //- A single-article product owns all shared data, so its article shows none of it
    //- (api docs/features/PRODUCT_ARTICLE_INHERITANCE.md section 10)
    .alert.info.single-article-note(role="note")
        p {{ $t('Name, texts, media, tags, prices, shipping points and all other product details are maintained on the product.') }}
            |
            |
            router-link(:to="`/catalog/product/${productId}/main`") {{ $t('Go to the product') }}
</template>

<i18n>
{
    "de": {
        "Name, texts, media, tags, prices, shipping points and all other product details are maintained on the product.": "Name, Texte, Medien, Tags, Preise, Versandpunkte und alle weiteren Produktangaben werden am Produkt gepflegt.",
        "Go to the product": "Zum Produkt"
    }
}
</i18n>

<script>
export default {
    name: 'SingleArticleNote',
    props: {
        productId: {
            type: [Number, String],
            required: true,
        },
    },
};
</script>

<style lang="sass" scoped>
.single-article-note
    // owns its spacing: the global .alert adds 20px above, which opens a gap at the top of a tab or drawer
    margin: 0 0 24px

    p
        margin: 0
</style>
